import { Box } from "@mui/material";

/** Decorative bell for the notifications page header. */
export function NotificationHeaderAside() {
  return (
    <Box
      aria-hidden
      sx={{
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        justifyContent: "center",
        width: 120,
        height: 96,
        flexShrink: 0,
      }}
    >
      <Box
        component="svg"
        viewBox="0 0 120 100"
        sx={{
          width: 112,
          height: "auto",
          filter: "drop-shadow(0 6px 14px color-mix(in srgb, var(--primary-600) 22%, transparent))",
        }}
      >
        <ellipse cx="60" cy="86" rx="28" ry="6" fill="var(--primary-600)" opacity="0.14" />

        {/* Bell body */}
        <path
          d="M60 18 C46 18 36 30 36 44 V58 L28 72 H92 L84 58 V44 C84 30 74 18 60 18 Z"
          fill="var(--primary-600)"
        />
        <path
          d="M60 18 C48 18 40 28 40 42 V56"
          fill="none"
          stroke="var(--primary-400)"
          strokeWidth="3"
          strokeLinecap="round"
          opacity="0.55"
        />
        <rect x="28" y="70" width="64" height="10" rx="5" fill="var(--primary-700)" />
        <circle cx="60" cy="84" r="6" fill="var(--primary-700)" />
        <circle cx="60" cy="16" r="5" fill="var(--primary-500)" />

        {/* Sparkles */}
        <path
          d="M96 22 L98 27 L103 29 L98 31 L96 36 L94 31 L89 29 L94 27 Z"
          fill="var(--primary-500)"
        />
        <path
          d="M22 34 L23.4 37.4 L27 39 L23.4 40.6 L22 44 L20.6 40.6 L17 39 L20.6 37.4 Z"
          fill="var(--primary-400)"
        />
        <path
          d="M104 48 L105.2 50.8 L108 52 L105.2 53.2 L104 56 L102.8 53.2 L100 52 L102.8 50.8 Z"
          fill="var(--primary-600)"
        />
        <circle cx="28" cy="56" r="2" fill="var(--primary-400)" opacity="0.8" />
      </Box>
    </Box>
  );
}
